// Author yjb
// Date 2021-12-13 19:10:50

class EmSicDowntimeRecordSdr {
constructor({
        id = null,
        sdrIdBda = '',
        bdaName = '',
        sdrBeginTime = '',
        sdrEndTime = '',
        sdrReason = '',
        sdrRecorder = '',
        sdrRecorderRealName = '',
        sdrAttachment = '',
        remark = '',
        sdrAttachmentList = ''}
= {}) {
    this.id = id;
    this.sdrIdBda = sdrIdBda;
    this.bdaName = bdaName;
    this.sdrBeginTime = sdrBeginTime;
    this.sdrEndTime = sdrEndTime;
    this.sdrReason = sdrReason;
    this.sdrRecorder = sdrRecorder;
    this.sdrRecorderRealName = sdrRecorderRealName;
    this.sdrAttachment = sdrAttachment;
    this.remark = remark;
    this.sdrAttachmentList = sdrAttachmentList;
}
}

function newEntity() {
return new EmSicDowntimeRecordSdr();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.statusCollection.emSicDowntimeRecordSdr.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'bdaName',
        label: 'label.em.statusCollection.emSicDowntimeRecordSdr.grid.bdaName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sdrBeginTime',
        label: 'label.em.statusCollection.emSicDowntimeRecordSdr.grid.sdrBeginTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sdrEndTime',
        label: 'label.em.statusCollection.emSicDowntimeRecordSdr.grid.sdrEndTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sdrReason',
        label: 'label.em.statusCollection.emSicDowntimeRecordSdr.grid.sdrReason',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sdrRecorderRealName',
        label: 'label.em.statusCollection.emSicDowntimeRecordSdr.grid.sdrRecorderRealName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sdrAttachmentList',
        label: 'label.em.statusCollection.emSicDowntimeRecordSdr.grid.sdrAttachmentList',
        sortable: true,
            isDetail: true,
        form: {
        type: 'emAttachment'
        }
        },
        {
        key: 'remark',
        label: 'label.em.statusCollection.emSicDowntimeRecordSdr.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    sdrIdBdaFilter : '',
    bdaNameFilter : '',
    sdrBeginTimeRteFilter : '',
    sdrBeginTimeLteFilter : '',
    sdrEndTimeRteFilter : '',
    sdrEndTimeLteFilter : '',
    sdrReasonFilter : '',
    sdrRecorderFilter : '',
    sdrRecorderRealNameFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'bdaNameFilter',
        label: 'label.em.statusCollection.emSicDowntimeRecordSdr.filter.bdaName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'sdrBeginTimeRteFilter',
        label: 'label.em.statusCollection.emSicDowntimeRecordSdr.filter.sdrBeginTimeRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'sdrBeginTimeLteFilter',
        label: 'label.em.statusCollection.emSicDowntimeRecordSdr.filter.sdrBeginTimeLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'sdrEndTimeRteFilter',
        label: 'label.em.statusCollection.emSicDowntimeRecordSdr.filter.sdrEndTimeRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'sdrEndTimeLteFilter',
        label: 'label.em.statusCollection.emSicDowntimeRecordSdr.filter.sdrEndTimeLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'sdrReasonFilter',
        label: 'label.em.statusCollection.emSicDowntimeRecordSdr.filter.sdrReason',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'sdrRecorderRealNameFilter',
        label: 'label.em.statusCollection.emSicDowntimeRecordSdr.filter.sdrRecorderRealName',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'bdaName',
        label: 'label.em.statusCollection.emSicDowntimeRecordSdr.entity.bdaName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emArchBasicData'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"sdrIdBda":"id"}'
                }
        },
        {
        key: 'sdrBeginTime',
        label: 'label.em.statusCollection.emSicDowntimeRecordSdr.entity.sdrBeginTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'sdrEndTime',
        label: 'label.em.statusCollection.emSicDowntimeRecordSdr.entity.sdrEndTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'sdrReason',
        label: 'label.em.statusCollection.emSicDowntimeRecordSdr.entity.sdrReason',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'sdrRecorderRealName',
        label: 'label.em.statusCollection.emSicDowntimeRecordSdr.entity.sdrRecorderRealName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclUser'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"sdrRecorder":"loginName"}'
                }
        },
        {
        key: 'remark',
        label: 'label.em.statusCollection.emSicDowntimeRecordSdr.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        },
        {
        key: 'sdrAttachmentList',
        label: 'label.em.statusCollection.emSicDowntimeRecordSdr.entity.sdrAttachment',
        sortable: false,
        disabled: false,
        form: {
        type: 'emAttachment'
            ,correspondingField: 'sdrAttachment'
                }
        }
]

export {EmSicDowntimeRecordSdr, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
